export const PACKAGE_LOADING = "charger/package/PACKAGE_LOADING";
export const PACKAGE_ERROR = "charger/package/PACKAGE_ERROR";
export const PACKAGE_GET_LIST = "charger/package/PACKAGE_GET_LIST";
export const PACKAGE_RESET_LIST = "charger/package/PACKAGE_RESET_LIST";
export const PACKAGE_ADD = "charger/package/PACKAGE_ADD";
export const PACKAGE_ADD_IMAGE = "charger/package/PACKAGE_ADD_IMAGE";
export const PACKAGE_GET_IMAGE = "charger/package/PACKAGE_GET_IMAGE";
export const PACKAGE_ASSIGN_TO_USERS_LIST = "charger/package/PACKAGE_ASSIGN_TO_USERS_LIST";



// WEBPACK FOOTER //
// ./src/actions/chargers/package/constants.js